import React from 'react';
import { bool, oneOf, string } from 'prop-types';
import { isOutletSku, isRetiredDesignSku } from '../../hooks/utils';
import classes from './outletTags.module.css'; // OUTLET for OUT- products, RETIRED DESIGN for DIS- products, and FINAL CALL (hf_hot_deal) always
// after one of them, never on its own. Non-outlet SKUs get no tags.

export var getOutletTagLabels = function getOutletTagLabels(sku, isFinalCall) {
  if (!isOutletSku(sku)) return [];
  var labels = [isRetiredDesignSku(sku) ? 'RETIRED DESIGN' : 'OUTLET'];
  if (isFinalCall) labels.push('FINAL CALL');
  return labels;
};
/**
 * HBF-145 outlet product tags (Figma "label new").
 *
 * @param {string} props.sku - product SKU, decides OUTLET vs RETIRED DESIGN
 * @param {boolean} props.isFinalCall - hf_hot_deal of the product
 * @param {string} props.variant - "card" (4px gap) or "pdp" (10px gap)
 * @param {string} props.className - extra classes for the wrapper
 */

var OutletTags = function OutletTags(_ref) {
  var sku = _ref.sku,
      isFinalCall = _ref.isFinalCall,
      variant = _ref.variant,
      className = _ref.className;
  var labels = getOutletTagLabels(sku, isFinalCall);
  if (!labels.length) return null;
  var rootClass = variant === 'pdp' ? classes.root_pdp : classes.root;
  return React.createElement("div", {
    className: className ? "".concat(rootClass, " ").concat(className) : rootClass
  }, labels.map(function (label) {
    return React.createElement("span", {
      key: label,
      className: classes.tag
    }, label);
  }));
};

OutletTags.propTypes = {
  sku: string,
  isFinalCall: bool,
  variant: oneOf(['card', 'pdp']),
  className: string
};
OutletTags.defaultProps = {
  isFinalCall: false,
  variant: 'card'
};
/**
 * A single FINAL CALL tag, used next to the price of a qualifying configuration on the Outlet PDP.
 */

export var FinalCallTag = function FinalCallTag(_ref2) {
  var className = _ref2.className;
  return React.createElement("span", {
    className: className ? "".concat(classes.tag, " ").concat(className) : classes.tag
  }, "FINAL CALL");
};
FinalCallTag.propTypes = {
  className: string
};
export default OutletTags;